function retrieveAutoCreateFinal(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/auto-create-final`);
}

function updateAutoCreateFinal(companyId, autoCreateFinal) {
    return window.tenantAxios.patch(`/company/${companyId}/auto-create-final`, autoCreateFinal);
}

export default {
    retrieveAutoCreateFinal,
    updateAutoCreateFinal,
};
